<template>
  <b-sidebar
    id="drawer-override-individu"
    :visible="visible"
    :title="mode === 'add' ? 'Tambah Approval Chain Override Individu' : 'Atur Approval Chain Override Individu'"
    backdrop-variant="dark"
    backdrop
    right
    shadow
    width="580px"
    sidebar-class="right-drawer"
    aria-hidden="false"
    @hidden="onClose"
  >
    <div class="p-[1.5rem] flex flex-col justify-between min-h-[calc(100vh-80px)]">
      <div class="space-y-[1.25rem]">
        <!-- Field 1: Karyawan -->
        <div>
          <!-- Mode Add: Dropdown Select Karyawan -->
          <div v-if="mode === 'add'">
            <label class="text-sm text-black mb-[.5rem] block">
              Pilih Karyawan
            </label>
            <v-select
              v-model="form.employee"
              :options="employeeOptions"
              :loading="isLoadingStaff"
              :filterable="false"
              label="name"
              placeholder="Pilih atau cari karyawan"
              class="custom-employee-select"
              @search="onSearchStaff"
            >
              <template #selected-option="option">
                <div class="flex items-center gap-[.625rem] py-[.125rem]">
                  <div class="size-[32px] rounded-lg bg-[#F1F5F9] text-[#64748B] text-xs font-semibold flex items-center justify-center shrink-0">
                    {{ option.initials || (option.name ? option.name.substring(0, 2).toUpperCase() : '') }}
                  </div>
                  <div>
                    <div class="text-sm font-medium text-black leading-tight">
                      {{ option.name }} <span
                        v-if="option.npk"
                        class="text-xs text-[#94A3B8] font-normal"
                      >({{ option.npk }})</span>
                    </div>
                    <div class="text-xs text-[#828282] leading-tight">
                      {{ option.role }}{{ option.division ? ` • ${option.division}` : '' }}
                    </div>
                  </div>
                </div>
              </template>
              <template #option="option">
                <div class="flex items-center gap-[.625rem] py-[.25rem] hover:cursor-pointer hover:bg-slate-50 rounded-lg">
                  <div class="size-[28px] rounded-lg bg-[#F1F5F9] text-[#64748B] text-[10px] font-semibold flex items-center justify-center shrink-0">
                    {{ option.initials || (option.name ? option.name.substring(0, 2).toUpperCase() : '') }}
                  </div>
                  <div>
                    <div class="text-xs font-medium text-black">
                      {{ option.name }} <span
                        v-if="option.npk"
                        class="text-[11px] text-[#94A3B8] font-normal"
                      >({{ option.npk }})</span>
                    </div>
                    <div class="text-[11px] text-[#828282]">
                      {{ option.role }}{{ option.division ? ` • ${option.division}` : '' }}
                    </div>
                  </div>
                </div>
              </template>
            </v-select>
          </div>

          <!-- Mode Edit: Read-only Card Karyawan -->
          <div v-else>
            <label class="text-sm text-black mb-[.5rem] block">
              Karyawan
            </label>
            <div class="border border-[#E2E8F0] rounded-xl p-[.75rem] bg-white flex items-center gap-[.75rem]">
              <div class="w-[36px] h-[36px] rounded-lg bg-[#F1F5F9] text-[#64748B] text-xs font-semibold flex items-center justify-center shrink-0">
                {{ employeeInitials }}
              </div>
              <div>
                <div class="text-sm font-medium text-black leading-tight">
                  {{ form.employee ? form.employee.name : '' }} <span
                    v-if="form.employee && form.employee.npk"
                    class="text-xs text-[#94A3B8] font-normal"
                  >({{ form.employee.npk }})</span>
                </div>
                <div class="text-xs text-[#828282] leading-tight">
                  {{ form.employee ? form.employee.role : '' }}{{ form.employee && form.employee.division ? ` • ${form.employee.division}` : '' }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Field 2: Approver -->
        <div>
          <label class="text-sm text-black mb-[.5rem] block">
            Approver
          </label>
          <v-select
            v-model="form.approver"
            :options="approverOptions"
            :loading="isLoadingStaff"
            :filterable="false"
            label="name"
            placeholder="Pilih atau cari karyawan"
            class="custom-employee-select"
            @search="onSearchStaff"
          >
            <template #selected-option="option">
              <div class="flex items-center gap-[.625rem] py-[.125rem]">
                <div class="size-[32px] rounded-lg bg-[#F1F5F9] text-[#64748B] text-xs font-semibold flex items-center justify-center shrink-0">
                  {{ option.initials || (option.name ? option.name.substring(0, 2).toUpperCase() : '') }}
                </div>
                <div>
                  <div class="text-sm font-medium text-black leading-tight">
                    {{ option.name }} <span
                      v-if="option.npk"
                      class="text-xs text-[#94A3B8] font-normal"
                    >({{ option.npk }})</span>
                  </div>
                  <div class="text-xs text-[#828282] leading-tight">
                    {{ option.role }}{{ option.division ? ` • ${option.division}` : '' }}
                  </div>
                </div>
              </div>
            </template>
            <template #option="option">
              <div class="flex items-center gap-[.625rem] py-[.25rem] hover:cursor-pointer hover:bg-slate-50 rounded-lg">
                <div class="size-[28px] rounded-lg bg-[#F1F5F9] text-[#64748B] text-[10px] font-semibold flex items-center justify-center shrink-0">
                  {{ option.initials || (option.name ? option.name.substring(0, 2).toUpperCase() : '') }}
                </div>
                <div>
                  <div class="text-xs font-medium text-black">
                    {{ option.name }} <span
                      v-if="option.npk"
                      class="text-[11px] text-[#94A3B8] font-normal"
                    >({{ option.npk }})</span>
                  </div>
                  <div class="text-[11px] text-[#828282]">
                    {{ option.role }}{{ option.division ? ` • ${option.division}` : '' }}
                  </div>
                </div>
              </div>
            </template>
          </v-select>
          <p
            v-if="isSelfApprovalConflict"
            class="text-xs text-[#DC2626] mt-[.375rem] mb-0 font-medium"
          >
            Karyawan tidak dapat menjadi approver untuk dirinya sendiri (self-approval conflict). Silakan pilih approver pengganti lain.
          </p>
          <p
            v-else
            class="text-xs text-[#828282] mt-[.375rem] mb-0"
          >
            Tentukan approver pengganti untuk menyelesaikan self-approval conflict.
          </p>
        </div>
      </div>

      <!-- Action Buttons Footer -->
      <div class="mt-[2rem]">
        <div
          v-if="mode === 'edit' && overrideData && overrideData.id"
          class="mb-[1rem] flex justify-center"
        >
          <BButton
            variant="link"
            size="sm"
            class="!text-[#DC2626] hover:!text-[#B91C1C] p-0 !flex items-center gap-[.35rem]"
            :disabled="isSubmitting"
            @click="handleDelete"
          >
            <span class="k-trash text-[16px] text-[#DC2626]" />
            <span class="text-xs font-medium">Hapus Override Individu Ini</span>
          </BButton>
        </div>
        <div class="flex items-between gap-[1rem]">
          <BButton
            size="md"
            variant="outline-primary"
            block
            :disabled="isSubmitting"
            @click="onClose"
          >
            Batalkan
          </BButton>
          <BButton
            size="md"
            variant="primary"
            block
            class="m-0 !flex items-center justify-center gap-1"
            :disabled="isSubmitting || (mode === 'add' ? !form.employee || !form.approver : !form.approver) || isSelfApprovalConflict"
            @click="handleSave"
          >
            <BSpinner
              v-if="isSubmitting"
              small
              class="mr-1"
            />
            <span>{{ mode === 'add' ? 'Tambahkan' : 'Simpan Perubahan' }}</span>
          </BButton>
        </div>
      </div>
    </div>
  </b-sidebar>
</template>

<style scoped>
::v-deep .b-sidebar-header,
::v-deep .b-sidebar-body {
  background-color: white;
}

::v-deep .custom-employee-select .vs__dropdown-toggle {
  border: 1px solid #E2E8F0;
  border-radius: 10px;
  min-height: 48px;
  padding: 4px 8px;
}

::v-deep .custom-employee-select .vs__selected-options {
  display: flex;
  align-items: center;
}

::v-deep .custom-employee-select .vs__selected {
  margin: 2px;
}

::v-deep .custom-employee-select .vs__actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  margin-left: auto;
  padding: 0;
  height: 100%;
}

::v-deep .custom-employee-select .vs__dropdown-toggle {
  display: flex;
  align-items: center;
}

::v-deep .vs__search:focus {
  outline: none;
}

::v-deep .btn-outline-primary,
::v-deep .btn-primary {
  border-radius: 10px;
}
</style>

<script>
import vSelect from 'vue-select'
import { searchApproverUsers } from '../config'

export default {
  name: 'DrawerOverrideIndividu',
  components: {
    vSelect,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: 'add', // 'add' | 'edit'
    },
    overrideData: {
      type: Object,
      default: () => ({}),
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      employeeOptions: [],
      isLoadingStaff: false,
      searchTimer: null,
      form: {
        employee: null,
        approver: null,
      },
    }
  },
  computed: {
    employeeInitials() {
      if (!this.form.employee) return 'CR'
      return this.form.employee.initials
        || (this.form.employee.name ? this.form.employee.name.substring(0, 2).toUpperCase() : 'CR')
    },
    approverOptions() {
      if (!this.form.employee) return this.employeeOptions
      return this.employeeOptions.filter(
        emp => (this.form.employee.id ? emp.id !== this.form.employee.id : true)
          && emp.name !== this.form.employee.name,
      )
    },
    isSelfApprovalConflict() {
      if (!this.form.employee || !this.form.approver) return false
      return Boolean(
        (this.form.employee.id && this.form.employee.id === this.form.approver.id)
        || (this.form.employee.name && this.form.employee.name === this.form.approver.name),
      )
    },
  },
  watch: {
    'form.employee': {
      handler(newEmp) {
        if (newEmp && this.form.approver) {
          if ((newEmp.id && newEmp.id === this.form.approver.id) || newEmp.name === this.form.approver.name) {
            this.form.approver = null
          }
        }
      },
    },
    visible(val) {
      if (val) {
        this.fetchStaffOptions('')
        this.initForm()
      }
    },
    overrideData: {
      deep: true,
      handler() {
        if (this.visible) {
          this.initForm()
        }
      },
    },
  },
  mounted() {
    this.fetchStaffOptions('')
  },
  methods: {
    initForm() {
      if (this.mode === 'edit' && this.overrideData) {
        const empFound = this.employeeOptions.find(
          e => e.id === this.overrideData.user_id || e.name === this.overrideData.name,
        )
        const appFound = this.employeeOptions.find(
          e => e.id === this.overrideData.approver_1_id || e.name === this.overrideData.approver,
        )

        this.form.employee = empFound || {
          id: this.overrideData.user_id,
          name: this.overrideData.name,
          role: this.overrideData.role || 'Staff',
          initials: (this.overrideData.name || '').substring(0, 2).toUpperCase(),
        }
        this.form.approver = appFound || {
          id: this.overrideData.approver_1_id,
          name: this.overrideData.approver,
          role: this.overrideData.approverRole || 'Approver',
          initials: (this.overrideData.approver || '').substring(0, 2).toUpperCase(),
        }
      } else {
        this.form = {
          employee: null,
          approver: null,
        }
      }
    },
    onClose() {
      this.$emit('on-close')
    },
    handleSave() {
      this.$emit('on-save', {
        mode: this.mode,
        id: this.overrideData ? this.overrideData.id : null,
        employee: this.form.employee,
        approver: this.form.approver,
        overrideData: this.overrideData,
      })
    },
    handleDelete() {
      this.$emit('on-delete', this.overrideData)
    },
    onSearchStaff(search) {
      if (this.searchTimer) clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        this.fetchStaffOptions(search || '')
      }, 400)
    },
    async fetchStaffOptions(keyword = '') {
      this.isLoadingStaff = true
      try {
        const list = await searchApproverUsers(keyword)
        if (Array.isArray(list)) {
          const map = new Map()
          if (this.form.employee && this.form.employee.id) {
            map.set(this.form.employee.id, this.form.employee)
          }
          if (this.form.approver && this.form.approver.id) {
            map.set(this.form.approver.id, this.form.approver)
          }
          list.forEach(item => map.set(item.id, item))
          this.employeeOptions = Array.from(map.values())

          if (this.form.employee && (this.form.employee.id || this.form.employee.user_id)) {
            const empId = this.form.employee.id || this.form.employee.user_id
            const foundEmp = this.employeeOptions.find(e => e.id === empId)
            if (foundEmp) this.form.employee = foundEmp
          }
          if (this.form.approver && (this.form.approver.id || this.form.approver.user_id)) {
            const apprId = this.form.approver.id || this.form.approver.user_id
            const foundAppr = this.employeeOptions.find(e => e.id === apprId)
            if (foundAppr) this.form.approver = foundAppr
          }
        }
      } catch (error) {
        // Fallback
      } finally {
        this.isLoadingStaff = false
      }
    },
  },
}
</script>
